const SOLUTION_ROUTES = {
  ALL_SOLUTIONS: "/solutions",
  INTELLIGENT_LOGSTREAM: "/solutions/intelligent-logstream",
  INTELLIGENT_TRACE_SAMPLING: "/solutions/intelligent-trace-sampling",
  INTELLIGENT_ALERTING: "/solutions/intelligent-alerting",
  PII_REDACTION: "/solutions/pii-redaction",
};

const CASE_STUDY_ROUTES = {
  CASE_STUDY: "/case-study",
  CASE_STUDY_SLUG: "/case-study/:slug",
};

const ADMIN_ROUTES = {
  ADMIN: "/admin",
  ADMIN_AUTH_ERROR: "/admin/auth/error",
  ADMIN_CONTENT_EDITOR: "/admin/content-editor",
};

const OCTANT_ROUTES = {
  OCTANT_PARENT: "/octant",
  OCTANT_PRODUCT: "/octant/:product",
  OCTANT_HOW_IT_WORKS: "/octant/how-it-works",
  OCTANT_CONNECT: "/octant/connect",
  OCTANT_CLARITY: "/octant/clarity",
  OCTANT_PULSE: "/octant/pulse",
  OCTANT_PRICING: "/octant/pricing",
  OCTANT_OPEN_SOURCE: "/octant/open-source",
};

export const ROUTE = {
  HOME: "/",
  ABOUT: "/about",
  BLOG_POST: "/blog/:slug",
  BLOG: "/blog",
  CAREERS: "/careers",
  EVENT: "/events/:slug",
  EVENTS: "/events",
  NEWS: "/news",
  PARTNERS: "/partners",
  PLATFORM: "/platform",
  PRIVACY: "/privacy-policy",
  ...SOLUTION_ROUTES,
  ...OCTANT_ROUTES,
  TERMS: "/terms",
  CONTACT: "#contact-us",
  SCHEDULE_CALL: "#schedule-call",
  ...CASE_STUDY_ROUTES,
  ...ADMIN_ROUTES,
} as const;
